import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { User } from 'src/app/core/models/user';
import { UserService } from 'src/app/core/services/user.service';
import { ClarificationQueryListService } from '../clarification-query-list.service';
import { QueryRequertTypeEnum } from 'src/app/core/models/PartnerQueryStatus';
import { QueryRequestModel } from 'src/app/core/models/QueryRequestModel';
import { catchError, map, of } from 'rxjs';
import { CalAngularService } from '@cvx/cal-angular';
import { BreadcrumbService } from 'src/app/core/services/breadcrumb.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { QueryStatus } from 'src/app/core/models/QueryStatus';
import { TableColumns } from '../Shared/TableColumns';
import { XlsxService } from 'src/app/shared/services/xlsx.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { DeleteQueryComponent } from '../delete-query/delete-query.component';

@Component({
  selector: 'app-query-list',
  templateUrl: './query-list.component.html',
  styleUrls: ['./query-list.component.less'],
  standalone:false
})
export class QueryListComponent implements OnInit {
  
  queryResponseEnum = QueryStatus.Responded;
  queryAssgnToDepRepEnum = QueryStatus.AssignedToDeptRep;
  queryRecycledEnum = QueryStatus.Recycled;
  queryAnsweredBySponsorEnum = QueryStatus.QueryAnsweredBySponsor;
  queryAnsweredByDeptEnum = QueryStatus.QueryAnsweredByDeptRep;
 
  queryDeleteByAdminEnum = QueryStatus.DeletedByRFCAdmin;
  queryDeleteByPartnerEnum = QueryStatus.DeletedByPartner;
  currentUser: User = new User;
  allQueryRequest: QueryRequestModel[] = [];
  public filteredQueryRequest: QueryRequestModel[] = [];
  sortMap: { [key: string]: string | null } = {
    QueryRequestNumber: null,
    Subject: null,
    PartnerQueryStatus: null,
    CompanyName: null,
    RequestorName: null
  };

  config: any;
  currentPageSize: number = 10;
  sortingName: string = "RequestedDate";
  isDesc: boolean = true;
  nonPartnerTableColumns = TableColumns.NON_PARTNER_TABLE_COLUMNS;
  partnerTableColumns = TableColumns.PARTNER_TABLE_COLUMNS;
  searchText: string = ''; // Holds the search input value
  exportData: { Title: string; Data: any[]; Headers: string[] }[] = [];
  constructor(private userService: UserService,
    private queryService: ClarificationQueryListService,
    private authService: CalAngularService,
    private breadcrumbService: BreadcrumbService,
    private modalService: NzModalService,
    private xlxsService: XlsxService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
  ) {
  }
  ngOnInit() {   
    this.currentUser = this.userService.getCurrentUser();  
    if (this.currentUser?.User_Code == null) {
      this.userService.userUpdated.subscribe((updatedUser: User) => {
        this.currentUser = updatedUser;
        this.initialLoading();
      }); 
    }else{
      this.initialLoading();
    }
    this.breadcrumbService.setBreadcrumbs([
      { label: 'Home', url: '/' },
      { label: 'Clarification Query', url: '/clarification-query' },
      { label: 'All Queries' }
    ]);
  }
  initialLoading(){
    this.queryService.getAllQueries(this.currentUser.User_Code ?? 0, QueryRequertTypeEnum.AllQueryRequest, 0).pipe(
      map((response: any) => {        
        this.allQueryRequest = response.output;
        
        this.filteredQueryRequest = this.allQueryRequest
          .filter(s => s.QueryDetailsStatus)
          .sort((a, b) => new Date(b.RequestedDate).getTime() - new Date(a.RequestedDate).getTime());
        this.config = {
          itemsPerPage: this.currentPageSize,
          currentPage: 1,
          totalItems: 0
        };
      }),
      catchError(error => {
        console.log(error);
        return of([]);
      })
    ).subscribe();
  }
  
  showDeleteConfirm(queryData: any): void {    
    this.modalService.confirm({
      nzTitle: 'Confirm !',
      nzContent: 'Are you sure, you want to <strong>Delete</strong> Query - <span class="referanceNumber"> '+queryData.QueryRequestNumber +'</span>?',
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => this.OnDeleteClick(queryData),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }
  OnDeleteClick(queryData: QueryRequestModel) {    
      this.modalService.create({
        nzTitle: '<span class="referanceNumber"> Delete Query</span>',
        nzOkText: 'Delete',
        nzClosable: false,
        nzFooter: null,
        nzAutofocus: null,
        nzContent: DeleteQueryComponent,
        nzData: { paramRequestModel: queryData },
      });
    }
  sortString(a: QueryRequestModel, b: QueryRequestModel) {
    return (a.QueryRequestNumber || '').localeCompare(b.QueryRequestNumber || '');
  }
  

  
  onSearch(): void {
    const searchTextLower = this.searchText.toLowerCase();

    // Only filter if the search text has at least 3 characters
    if (searchTextLower.length >= 3) {
      this.filteredQueryRequest = this.allQueryRequest.filter((item) =>
        Object.values(item).some((value) =>
          value?.toString().toLowerCase().includes(searchTextLower)
        )
      );
    } else {
      // Reset the filtered data to the original data if search text is less than 3 characters
      this.filteredQueryRequest = [...this.allQueryRequest];
    }
  }
  exportToExcel()
  {
    this.exportData = [];
    let currentDate =new Date();
    let exportData = [];
    let headers = ["Reference Number",
      "Request Status",
      "Requestor Name",
      "Company",
      "Block",
      "Request Date",
      "Priority",
      "Confidential",
      "Department",
      "Sub Deptartment",
      "Request Completion Date",
      "Request Created By"
    ];

    exportData = this.filteredQueryRequest.map(function (item) {
      return {
        "Reference Number": item.QueryRequestNumber,
        "Request Status": item.QueryStatus,
        "Requestor Name": item.RequestorName,
        "Company": item.CompanyName,
        "Block": item.Block,
        "Request Date": item.RequestedDate,
        "Priority" : item.PriorityLevel,
        "Confidential" : item.Confidential,
        "Department": item.Department,
        "Sub Deptartment": item.SubDeptartment,
        "Request Completion Date": item.RespondedDate,
        "Request Created By": item.CreatedByUserName
      };
    });

    this.exportData.push({ Title: 'All-Query-Request', Data: exportData, Headers: headers });
    this.xlxsService.export(this.exportData, "All-Query-Request_" + this.datepipe.transform(currentDate, 'dd-MMM-yyyy'));
  }
}
